import React, {
  createRef, useRef, useCallback, useState,
} from 'react';
import ZoomImageThumbnails from './ZoomImageThumbnails';
import ZoomImage from './ZoomImage';

export default function DesktopZoomImages({
  orderedImages,
  productId,
  activeImage,
  altZoomImage,
  setActiveImage,
  tmntData,
  handleImageErrorOrRemoval,
}) {
  const [loadedImageCounter, setLoadedImageCounter] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const imagesLength = orderedImages?.length;
  const imageRefs = useRef([]);
  if (imageRefs.current.length !== imagesLength) {
    imageRefs.current = Array(imagesLength).fill().map((_, i) => imageRefs.current[i] || createRef());
  }

  const onImageLoad = useCallback(() => {
    const index = orderedImages.findIndex((image) => image.imageId === activeImage.imageId);
    imageRefs.current[index]?.current?.scrollIntoView();

    setLoadedImageCounter(loadedImageCounter + 1);
    if (loadedImageCounter === imagesLength) {
      setIsLoaded(true);
    }
  }, [activeImage, orderedImages, loadedImageCounter, imagesLength]);

  const onThumbnailClick = (index) => {
    setActiveImage(orderedImages[index]);
    imageRefs.current[index]?.current?.scrollIntoView();
  };

  const onIsVisible = useCallback((index) => {
    if (isLoaded && imagesLength) {
      setActiveImage(orderedImages[index]);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderedImages?.length, isLoaded]);

  return (
    <>
      {orderedImages?.length > 1 && (
      <ZoomImageThumbnails
        activeImage={activeImage}
        data-selected={activeImage}
        orderedImages={orderedImages}
        onThumbnailClick={onThumbnailClick}
        tmntData={tmntData}
      />
      )}
      <ul className="product-zoom__images" data-testid="product-zoom-images-wrapper">
        {orderedImages?.map((image, index) => (
          <li className="product-zoom__image" data-collection={productId} tabIndex="-1" key={image.imageId} id={image.imageId} ref={imageRefs.current[index]}>
            <ZoomImage
              imageData={image}
              productId={productId}
              altZoomImage={altZoomImage}
              onImageLoad={onImageLoad}
              onIsVisible={onIsVisible}
              imageIndex={index}
              handleImageErrorOrRemoval={handleImageErrorOrRemoval}
            />
          </li>
        ))}
      </ul>
    </>
  );
}
